import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=d1fee29e&"
import script from "./Contact.vue?vue&type=script&lang=ts&"
export * from "./Contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1fee29e')) {
      api.createRecord('d1fee29e', component.options)
    } else {
      api.reload('d1fee29e', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=d1fee29e&", function () {
      api.rerender('d1fee29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact/Contact.vue"
export default component.exports